/**
 * Résout l'ID méthode côté config orga (aligné sur les Cloud Functions).
 */
export function resolveShippingMethodConfigId(
  deliveryInfo:
    | {
        deliveryMethod?: string | null;
        shippingMethodId?: string | null;
        methodId?: unknown;
        sendcloudMethodId?: unknown;
      }
    | null
    | undefined
): string | null {
  if (!deliveryInfo) return null;

  const dm = deliveryInfo.deliveryMethod;
  if (typeof dm === 'string' && dm.trim() !== '') return dm.trim();

  const methodField = (deliveryInfo as { method?: unknown }).method;
  if (typeof methodField === 'string' && methodField.trim() !== '') return methodField.trim();

  const sid = deliveryInfo.shippingMethodId;
  if (typeof sid === 'string' && sid.trim() !== '') return sid.trim();

  const mid = deliveryInfo.methodId;
  if (mid != null) {
    if (typeof mid === 'number') {
      if (Number.isFinite(mid)) {
        return `sendcloud_${String(Math.trunc(mid))}`;
      }
    } else {
      const s = String(mid).trim();
      if (s !== '' && s.toLowerCase() !== 'nan') {
        if (/^\d+$/.test(s)) return `sendcloud_${s}`;
        return s;
      }
    }
  }

  const scm = deliveryInfo.sendcloudMethodId;
  if (typeof scm === 'number' && Number.isFinite(scm)) {
    return `sendcloud_${String(Math.trunc(scm))}`;
  }
  if (typeof scm === 'string' && /^\d+$/.test(scm.trim())) {
    return `sendcloud_${scm.trim()}`;
  }

  return null;
}

/** Libellé court pour l’admin (sans préfixe sendcloud_ pour les ids numériques legacy). */
export function formatShippingMethodIdForDisplay(configId: string | null): string | null {
  if (!configId) return null;
  return configId.startsWith('sendcloud_') ? configId.slice('sendcloud_'.length) : configId;
}
